import React, { useState } from "react";

import dayjs from "dayjs";
import { Formik, FieldArray } from "formik";
import { Plus } from "icons";
import Pluralize from "pluralize";
import { isEmpty } from "ramda";

import { Button, Typography } from "clearsense-ui/components";

import AddNewValue from "./AddNewValue";
import ValueAccordion from "./ValueAccordion";

import { CREATE_REFERENCE_VALUES_VALIDATION_SCHEMA } from "../../../constants/createReferenceSource";

const CreateValues = ({ referenceValues, setReferenceValues }) => {
  const [selectedValueIndex, setSelectedValueIndex] = useState();
  const [isAddValue, setIsAddValue] = useState(false);
  const [isEditValue, setIsEditValue] = useState(false);

  const handleAddNewValue = addValue => {
    setSelectedValueIndex();
    setIsAddValue(true);
    setIsEditValue(false);
    addValue({
      name: "",
      description: "",
      start_date: dayjs(new Date()).format("YYYY-MM-DD"),
      end_date: dayjs(new Date()).format("YYYY-MM-DD"),
    });
  };

  const handleUpdateValue = index => {
    setSelectedValueIndex(index);
    setIsAddValue(false);
    setIsEditValue(true);
  };

  const onValueClose = () => {
    setIsAddValue(false);
    setSelectedValueIndex();
    setIsEditValue(false);
  };

  const renderValueFields = (valueIndex, removeValue, value, valuesCount) => {
    if (isAddValue && valueIndex === valuesCount - 1) {
      return (
        <AddNewValue
          key={valueIndex}
          valueIndex={valueIndex}
          isEditValue={isEditValue}
          onValueClose={onValueClose}
          removeValue={removeValue}
          setReferenceValues={setReferenceValues}
        />
      );
    }

    return selectedValueIndex === valueIndex ? (
      <AddNewValue
        key={valueIndex}
        valueIndex={valueIndex}
        isEditValue={isEditValue}
        onValueClose={onValueClose}
        removeValue={removeValue}
        setReferenceValues={setReferenceValues}
      />
    ) : (
      <ValueAccordion
        valueIndex={valueIndex}
        value={value}
        handleUpdateValue={handleUpdateValue}
      />
    );
  };

  return (
    <div className="mb-14 w-full">
      <Typography
        style="condensedMedium"
        className="mb-8 text-gray-500 dark:text-cs-ui-gray-400"
      >
        This Reference Source has
        {isEmpty(referenceValues)
          ? " no values yet."
          : ` ${Pluralize("value", referenceValues?.length, true)}.`}
      </Typography>

      <Formik
        initialValues={{ referenceValues: [] }}
        validationSchema={CREATE_REFERENCE_VALUES_VALIDATION_SCHEMA}
        enableReinitialize
      >
        {({ values }) => (
          <FieldArray name="referenceValues">
            {({ remove, push }) => (
              <div className="flex flex-col space-y-2">
                {values.referenceValues?.length > 0 &&
                  values.referenceValues?.map((value, index) =>
                    renderValueFields(
                      index,
                      remove,
                      value,
                      values.referenceValues?.length
                    )
                  )}
                <div className="flex">
                  <Button
                    onClick={() => handleAddNewValue(push)}
                    label="Add Value"
                    icon={Plus}
                    className="mt-4"
                    disabled={isAddValue}
                    data-cy="add-value-button"
                  />
                </div>
              </div>
            )}
          </FieldArray>
        )}
      </Formik>
    </div>
  );
};

export default CreateValues;
